/**
 * Generated by orval v6.20.0 🍺
 * Do not edit manually.
 * portrich-api
 * OpenAPI spec version: 0.0.0
 */

export type TradePriceManagementsMarineListIncoterms = typeof TradePriceManagementsMarineListIncoterms[keyof typeof TradePriceManagementsMarineListIncoterms];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradePriceManagementsMarineListIncoterms = {
  CFR: 'CFR',
  CIF: 'CIF',
  CIP: 'CIP',
  CPT: 'CPT',
  DAP: 'DAP',
  DAT: 'DAT',
  DDP: 'DDP',
  DDU: 'DDU',
  DPU: 'DPU',
  EXW: 'EXW',
  FAS: 'FAS',
  FCA: 'FCA',
  FOB: 'FOB',
} as const;
